export default {
  data() {
    return {
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      tableData: [],
      tableColumns: [
        {
          fixed: 'left',
          title: '序号',
          width: 80,
          align: 'center',
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
        },
        {
          title: '客户编号',
          width: 120,
          dataIndex: 'code',
        },
        {
          title: '客户名称',
          width: 160,
          dataIndex: 'name',
        },
        {
          title: '业务类型',
          width: 80,
          dataIndex: 'bgName',
        },
        {
          title: 'Segmentlevel',
          width: 100,
          dataIndex: 'segment',
        },
        {
          title: '账期',
          width: 80,
          dataIndex: 'term',
        },
        {
          title: '提示',
          width: 100,
          dataIndex: 'error',
        },
      ],
    }
  },
  methods: {
    // 查询
    handleSearch(data) {
      this.searchForm = { ...data }
      this.pageData.current = 1
      this._getTableData()
    },
    // 点击分页按钮
    handleClickPage({ current, pageSize }) {
      this.pageData = { ...this.pageData, current, pageSize }
      this._getTableData()
    },
  },
}
